/* eslint-disable camelcase */
import { IOrderV1_1 } from "../types";

export const getActualAmountOfOrder = (order: IOrderV1_1): number =>
    order.orderLineItems?.reduce(
        (acc, currentOrderLineItem) =>
            acc + currentOrderLineItem.price * currentOrderLineItem.quantity,
        0,
    );
